/* Copyright (c) 2017 Backpack Health LLC */

import * as _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function getStepStyle(styleSteps, value) {
  if (_.isEmpty(styleSteps)) {
    return {};
  } else {
    const filtered = styleSteps.filter((s) => (s.minValue <= value));
    if (filtered.length > 0) {
      return filtered.reduce((prev, s) => (s.minValue > prev.minValue ? s : prev));
    } else {
      return {};
    }
  }
}

const ProgressIndicator = (props) => {
  let progress = (props.value / props.maxValue) * 100;
  progress = Math.max(progress, 0);
  progress = Math.min(progress, 100);
  const styleData = getStepStyle(props.styleSteps, props.value);
  const colorClassName = _.get(styleData, 'colorClassName', '');
  const meterClassName = classnames('cmp-progress-meter', {
    'has-background': props.hasBackground,
  });
  return (
    <div className={classnames('cmp-progress-indicator',props.className)} style={props.style}>
      <div style={{ height: props.height }} className={meterClassName}>
        <div
          className={classnames('cmp-progress-meter-progress', colorClassName)}
          style={{ width: `${progress}%`, borderRadius: 4 }}
        />
      </div>
      {
        props.title ? <div className="cmp-progress-indicator-title">{props.title}</div> : null
      }
    </div>
  );
};
ProgressIndicator.propTypes = {
  maxValue: PropTypes.number,
  height: PropTypes.number,
  value: PropTypes.number.isRequired,
  title: PropTypes.any,
  hasBackground: PropTypes.bool,
  style: PropTypes.any,
  className: PropTypes.string,
  styleSteps: PropTypes.arrayOf(PropTypes.shape({
    minValue: PropTypes.number,
    colorClassName: PropTypes.string,
  })),
};
ProgressIndicator.defaultProps = {
  maxValue: 100,
  height: 4,
  styleSteps: [
    {
      minValue: 0,
      colorClassName: '',
    },
    {
      minValue: 1,
      colorClassName: 'bkgd-color-poor',
    },
    {
      minValue: 50,
      colorClassName: 'bkgd-color-weak',
    },
    {
      minValue: 75,
      colorClassName: 'bkgd-color-good',
    },
    {
      minValue: 100,
      colorClassName: 'bkgd-color-strong',
    },
  ],
};

export const ProfileLoadingBar = (props) => {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    setProgress(100);
  }, []);

  return (
    <div
      className="cmp-progress-indicator border-color-profile-accent bkgd-color-profile"
      style={{
        borderWidth: 1,
        borderStyle: 'solid',
      }}>
      <div className="cmp-progress-meter">
        <div
          className="bkgd-color-profile-accent"
          style={{
            width: `${progress}%`,
            height: 4,
            borderRadius: 4,
            transition: `width ${props.totalTime}ms ease-in`,
          }}
        />
      </div>
    </div>
  );
};
ProfileLoadingBar.propTypes = {
  totalTime: PropTypes.number,
};

export const DownloadingProgressBar = (props) => {
  const { progress, style, totalTime } = props;

  return (
    <div
      className="cmp-progress-indicator border-color-success"
      style={{
        borderWidth: 1,
        borderStyle: 'solid',
        borderTop: 'none',
        borderBottom: 'none',
        ...style,
      }}>
      <div className="cmp-progress-meter">
        <div
          className="bkgd-color-success"
          style={{
            width: `${progress}%`,
            height: 4,
            borderRadius: 4,
            transition: `width ${totalTime}ms ease-in`,
          }}
        />
      </div>
    </div>
  );
};
DownloadingProgressBar.propTypes = {
  progress: PropTypes.number,
  style: PropTypes.any,
  totalTime: PropTypes.number,
};

export default ProgressIndicator;
